import { getPaymentMethodsQueryForOrder } from '../utils/payment-methods-query';
import { loadPaymentMethodsForQuery } from './load-payment-methods-for-query';
/**
 * Loads payment methods for a given in-progress order.
 */
export const loadPaymentMethodsForOrder = async (order, reloadCachedData = false) => {
    const query = getPaymentMethodsQueryForOrder(order);
    return await loadPaymentMethodsForQuery(query, reloadCachedData);
};
